import { render, staticRenderFns } from "./widget-user-progress.vue?vue&type=template&id=1703d55c&scoped=true"
import script from "./widget-user-progress.vue?vue&type=script&lang=js"
export * from "./widget-user-progress.vue?vue&type=script&lang=js"
import style0 from "./widget-user-progress.vue?vue&type=style&index=0&id=1703d55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1703d55c",
  null
  
)

export default component.exports